export enum ListMenuCardAction {
  PUBLISH = 'PUBLISH',
}
